import { Site } from '@/common/const'
import { t } from '@/plugins/i18n'

export const tipList:any = {
  oemStatus: {
    name: 'oemStatus',
    title: t('＜农历新年前希望交付的OEM订单推荐下单时间＞'),
    // 开始时间
    startTime: '2024/01/04 00:00:00',
    // 结束时间
    endTime: '2024/01/18 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 0,
    // 展示站点
    station: ['ja', 'en'],
    tag: [
      {
        title: t('服装·杂货'),
        time: t('1月5日（星期五）')
      },
      {
        title: t('材料'),
        time: t('1月18日（星期四）')
      }
    ],
    text: [
      {
        text: t('※即使超过接单截止时间，仍然可以下OEM订单，但发货可能会延迟到2月下旬以后。')
      },
      {
        text: t('※根据工厂的情况，即使在接单截止时间前下的OEM订单，也有可能在春节之后才发货。')
      }
    ]
  },
  stopPurchase: {
    name: 'stopPurchase',
    title: t('成品采购春节停止下单时间'),
    // 开始时间
    startTime: '2024/01/04 00:00:00',
    // 结束时间
    endTime: '2024/02/03 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 0,
    // 展示站点
    station: ['ja', 'en'],
    tag: [
      {
        title: t('市场购'),
        time: t('１月27日')
      },
      {
        title: t('Taobao・1688等'),
        time: t('2月4日')
      }
    ],
    text: [
      {
        text: t('建议春节前尽快囤货')
      },
      {
        text: t('※由于部分店铺已经开始休业，2月4日之前下单的商品也有节前发不出货的可能')
      },
      {
        text: t('※2月4日（日）~2月17日（土）的订单我们也受理，统一在2月17日之后采购')
      },
      {
        text: t('※为防止断货建议1月屯两个月库存')
      }
    ]
  },
  expressTime: {
    name: 'expressTime',
    title: t('春节前希望发货的发货委托制作的推荐期间'),
    // 开始时间
    startTime: '2024/01/15 00:00:00',
    // 结束时间
    endTime: '2024/02/06 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 0,
    // 展示站点
    station: ['ja', 'en'],
    tag: [
      {
        title: t('船运节前出货发货依赖截单时间'),
        time: t('2月1日（木）19时')
      },
      {
        title: t('空运节前出货发货依赖截单时间'),
        time: t('2月6日（火）19时')
      }
    ],
    text: [
      {
        text: t('截单时间之后的发货依赖可能会在节后发货')
      },
      {
        text: t('春节期间仓库爆单请提前安排发货')
      }
    ]
  },
  oemSendCreate: {
    name: 'oemSendCreate',
    title: t('＜旧正月 OEM发货和报价申请休假通知＞'),
    // 开始时间
    startTime: '2024/02/01 00:00:00',
    // 结束时间
    endTime: '2024/02/17 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 2,
    // 展示站点
    station: ['ja', 'en'],
    tag: [
      {
        title: t('休假期间'),
        time: t('2月7日（星期三）至2月17日（星期六）')
      }
    ],
    text: [
      {
        text: t('※即使在休假期间，我们仍然接受OEM发货和报价申请。')
      },
      {
        text: t('我们将在旧正月过后顺序处理，请尽早提交您希望订购的商品。')
      },
      {
        text: t('我们建议您尽早提出申请。')
      }
    ]
  },
  stopPurchaseOrder: {
    name: 'stopPurchaseOrder',
    title: t('＜旧正月期间成品采购停业通知＞'),
    // 开始时间
    startTime: '2024/02/04 00:00:00',
    // 结束时间
    endTime: '2024/02/17 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 0,
    // 展示站点
    station: ['ja', 'en'],
    tag: [
      {
        title: t('休业期间'),
        time: t('2月4日（星期日）至2月17日（星期六）')
      }
    ],
    text: [
      {
        text: t('※即使在休业期间，我们仍然接受订单。')
      },
      {
        text: t('我们将在旧正月过后按顺序进行处理，请尽早提交您希望订购的商品。')
      }
    ]
  },
  stopWarehouse: {
    name: 'stopWarehouse',
    title: t('＜旧正月仓库停业通知＞'),
    // 开始时间
    startTime: '2024/02/09 00:00:00',
    // 结束时间
    endTime: '2024/02/17 23:59:59',
    // 限制会员等级展示默认0
    templateLevel: 0,
    // 展示站点
    station: ['ja', 'en'],
    tag: [
      {
        title: t('D2C（仓库发货停止）'),
        time: t('2月9日（星期五）至2月14日（星期三）')
      },
      {
        title: t('B2B（仓库发货停止）'),
        time: t('2月9日（星期五）至2月17日（星期六）')
      }
    ],
    text: [
      {
        text: t('※即使在休业期间，仍然可以创建发货请求，但我们将按照重新开放业务的顺序进行处理。')
      }
    ]
  }
}
